<template>
  <div>
    <h2 class="text-center pb-4">{{ $t("heading") }}</h2>
    <div class="ad-container d-flex align-items-center justify-content-center">
      <div class id="carousel-container">
        <carousel
          :loop="true"
          :autoplay="true"
          :scrollPerPage="false"
          :perPageCustom="[
            [230, 1],
            [768, 2],
            [960, 3],
            [1200, 4],
          ]"
          :paginationEnabled="false"
          ref="carousel"
        >
          <slide
            v-for="partner in partners"
            :key="partner.id"
            class="text-center"
          >
            <a :href="partner.link" target="_blank" rel="no-follow">
              <b-img :src="partner.image.url" fluid class="w-100 h-100 p-3" />
            </a>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  i18nOptions: {
    namespaces: "components",
    keyPrefix: "partners",
  },
  data: function () {
    return {
      loading: false,
      partners: [],
    };
  },
  created: function () {
    this.getData();
  },
  methods: {
    getData: function () {
      this.loading = true;
      this.$http.get("/api/partners/footer").then((repsonse) => {
        this.partners = repsonse.data;
        this.loading = false;

        // fire resize events
        var resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent);
      });
    },
  },

  mounted: function () {},
};
</script>
<style lang="scss" scoped>
</style>
